import { Link, usePage } from "@inertiajs/react";
import type { PublicProps } from "@/types";
import { ticketIcon } from "./NavItems";
import Icon from "@/components/ui/Icon";
import logoWordmark from "@/assets/brand/logo-wordmark.png";

// Mobile-only header: identity on the left, balance and account on the right.
// The desktop rail carries all of this, so it hides from `lg` up.
export default function TopBar() {
  const { props } = usePage<PublicProps>();
  const user = props.user;

  if (!user) {
    return (
      <header className="border-line bg-surface sticky top-0 z-40 flex items-center gap-3 border-b-2 px-4 py-2.5 lg:hidden">
        <Link href="/events" className="min-w-0 flex-1">
          <img
            src={logoWordmark}
            alt={props.program.name}
            className="h-8 w-auto object-contain object-left"
          />
        </Link>
        <a
          href="/auth/hca"
          className="border-line bg-goldenrod text-ink font-display text-caption border-2 px-3 py-1.5 font-bold"
        >
          Log in
        </a>
      </header>
    );
  }

  return (
    <header className="border-line bg-surface sticky top-0 z-40 flex items-center gap-3 border-b-2 px-4 py-2.5 lg:hidden">
      <Link href="/home" className="min-w-0 flex-1">
        <img
          src={logoWordmark}
          alt={props.program.name}
          className="h-8 w-auto object-contain object-left"
        />
      </Link>

      <div className="border-line bg-goldenrod flex items-center gap-1.5 border-2 px-2.5 py-1">
        <Icon src={ticketIcon} label="Tickets" className="h-4 w-4" />
        <span className="font-display text-caption text-ink font-bold">
          {user.balance}
        </span>
      </div>

      <Link
        href="/notifications"
        className="relative flex h-8 w-8 items-center justify-center"
      >
        <Icon
          src="/icons/notification-black.svg"
          label="Notifications"
          className={`h-5 w-5 ${
            user.unread_notification_count > 0
              ? "text-sunset-orange"
              : "text-ink"
          }`}
        />
      </Link>

      <Link
        href="/me"
        className="border-line bg-surface-plain h-8 w-8 shrink-0 overflow-hidden rounded-full border-2"
      >
        {user.avatar ? (
          <img
            src={user.avatar}
            alt="Account"
            className="h-full w-full object-cover"
          />
        ) : (
          <span className="font-display text-caption text-ink flex h-full w-full items-center justify-center font-bold">
            {user.username?.charAt(0) ?? "?"}
          </span>
        )}
      </Link>
    </header>
  );
}
